var map = {
	"./card-5AF2EC.png": "388a",
	"./card-96D5FF.png": "038a",
	"./card-ABC4FF.png": "e2a5",
	"./card-BAFAD7.png": "0351",
	"./card-D3DBE9.png": "62f6",
	"./card-EBD9FF.png": "f2238",
	"./card-FFDACA.png": "f55f",
	"./card-FFEDC1.png": "a227"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6edc";